module.exports = __webpack_public_path__ + "static/scale-model-of-escondido-california-9efc1d98148c4a193076895b22113720.png";